import { Injectable } from '@angular/core';
import { environment } from '@lentau/core/environments';
import { OtelcolConfig } from './open-telemetry.interfaces';
import { isLenta, isDom, isMonetka, isSuperJam, isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import {
  OtelProdUrl,
  OtelQAUrl,
  ServiceNameMonetka,
  ServiceNameSuperJam,
  ServiceNameLenta,
  ServiceNameDom,
  ServiceNameUtk,
} from './open-telemetry.config';

@Injectable({
  providedIn: 'root',
})
export class OpenTelemetryConfigFactory {
  public get(): OtelcolConfig {
    const isProd: boolean = environment.production;
    const probabilitySampler: string = isProd ? '0.3' : '1';

    return {
      commonConfig: {
        console: false,
        production: true,
        serviceName: this.getServiceName(),
        probabilitySampler,
      },
      otelcolConfig: {
        concurrencyLimit: 10,
        timeoutMillis: 15000,
        url: this.getUrl(),
        headers: {
          Authorization: 'Basic ' + btoa('otellentauser:shae7AifeiveiYiiHethohvo3maichae'),
        },
      },
    };
  }

  private getServiceName(): string {
    if (isLenta()) {
      return ServiceNameLenta;
    }
    if (isMonetka()) {
      return ServiceNameMonetka;
    }
    if (isSuperJam()) {
      return ServiceNameSuperJam;
    }
    if (isUtk()) {
      return ServiceNameUtk;
    }
    if (isDom()) {
      return ServiceNameDom;
    }
    return ServiceNameLenta;
  }

  private getUrl(): string {
    return environment.production ? OtelProdUrl : OtelQAUrl;
  }
}
